import { setContext } from 'apollo-link-context';

import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

const host = window.location.host

let uri = "https://production.api.connect.cdi.fluenty.co.za"
let logo = "cdi"

switch(host) {
  case "app.cdiconnect.com":
    uri = 'https://production.api.connect.cdi.fluenty.co.za'
    logo = "cdi"

    break

  case "production.connect.cdi.fluenty.co.za":
    uri = 'https://production.api.connect.cdi.fluenty.co.za'
    logo = "cdi"

    break

  case "connect.cdi.fluenty.co.za":
    uri = 'https://staging.api.connect.cdi.fluenty.co.za'
    logo = "cdi"

    break

  case "pepsico.cdiconnect.com":
    logo = "pepsico"
    uri = "https://production.api.connect.cdi.fluenty.co.za"
    break;

  default:
    uri = process.env.REACT_APP_BACKEND_DEFAULT_URI ?? 'http://localhost:4000'
    logo = "cdi"

    break
}

const httpLink = new HttpLink({
  uri: uri,
  headers: {
    "keep-alive": "true"
  }
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    }
  }
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache'
  },
  query: {
    fetchPolicy: 'no-cache'
  },
}

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
});

export {
  client,
  logo
}
